import React from "react";
import { AHIcon, Box, ColorType, useLayoutContext } from "arkh";
import { graphql, useFragment } from "react-relay";
import {
  LinkedItemContainer,
  LinkedItemSubtitle,
  LinkedItemTitle,
} from "./LinkedItemContainer";
import { Image } from "expo-image";
import { LinkedStoreProductItem_StoreProduct$key } from "./__generated__/LinkedStoreProductItem_StoreProduct.graphql";
import { ViewStyle } from "react-native";

export function LinkedStoreProductItemComponent(props: {
  unLinkProduct?: (id: string) => void;
  onPressProduct: (id: string) => void;
  borderColor?: ColorType;

  product: {
    id: string;
    imageUrl: string | null;
    partNumber: string | null;
    name: string | null;
  };
}) {
  const layout = useLayoutContext();

  return (
    <LinkedItemContainer
      onPress={() => {
        props.onPressProduct(props.product.id);
      }}
      onRemove={
        props.unLinkProduct
          ? () => {
              props.unLinkProduct?.(props.product.id);
            }
          : undefined
      }
      borderColor={props.borderColor}
    >
      <AHIcon type="product" color="text-secondary" spaceRight="small" />
      <Box
        style={{
          height: "100%",
          flex: 1,
          justifyContent: "center",
        }}
      >
        <LinkedItemTitle>{props.product.name}</LinkedItemTitle>
        {props.product.partNumber ? (
          <LinkedItemSubtitle>{props.product.partNumber}</LinkedItemSubtitle>
        ) : null}
      </Box>
      {props.product.imageUrl ? (
        <Box
          style={{
            marginLeft: layout.space.small,
            height: layout.circle.medium,
            width: layout.circle.medium,
            overflow: "hidden",
          }}
          color="surface"
          cornerRadius="medium"
        >
          <Image
            source={{ uri: props.product.imageUrl }}
            contentFit="cover"
            style={{
              flex: 1,
            }}
          />
        </Box>
      ) : null}
    </LinkedItemContainer>
  );
}

export function LinkedStoreProductItem(props: {
  product: LinkedStoreProductItem_StoreProduct$key;
  unLinkProduct?: (id: string) => void;
  onPressProduct: (id: string) => void;
  borderColor?: ColorType;

  maxWidth?: ViewStyle["maxWidth"];
}) {
  const product = useFragment(
    graphql`
      fragment LinkedStoreProductItem_StoreProduct on StoreProduct {
        id
        imageUrl
        partNumber
        name
      }
    `,
    props.product
  );
  return (
    <LinkedStoreProductItemComponent
      onPressProduct={props.onPressProduct}
      borderColor={props.borderColor}
      unLinkProduct={props.unLinkProduct}
      product={product}
    />
  );
}
